import ViewProducts from '../implementations/View/Products';
import ViewDossiersContent from '../implementations/View/Dossiers/Content';
import ViewDossiersRelated from '../implementations/View/Dossiers/Related';
import ViewArticleDossiers from '../implementations/View/Article/Dossiers';
import ViewExpertDossiers from '../implementations/View/Expert/Dossiers';
import ViewExpertPublications from '../implementations/View/Expert/Publications';
import ViewExpertContent from '../implementations/View/Expert/Content';
import ViewAgendaOverview from '../implementations/View/Agenda/Overview';
import ViewAgendaUpcoming from '../implementations/View/Agenda/Upcoming';
import ViewDossierMenu from '../implementations/View/DossierMenu';
import ViewArticlesPromoted from '../implementations/View/ArticlesPromoted';
import ViewMilestones from '../implementations/View/Milestones';
import ViewThemes from '../implementations/View/Themes';
import ViewPillars from '../implementations/View/Pillars';
import ViewWorkfieldsTheme from '../implementations/View/WorkfieldsTheme';
import ViewSubjectsTheme from '../implementations/View/SubjectsTheme';

const mappers = {
  views_block__products_block_1: ViewProducts,
  views_block__dossier_content_block_1: ViewDossiersContent,
  views_block__article_dossiers_related_block_1: ViewArticleDossiers,
  views_block__expert_dossiers_related_block_1: ViewExpertDossiers,
  views_block__expert_external_publications_block_1: ViewExpertPublications,
  views_block__dossiers_related_block_1: ViewDossiersRelated,
  views_block__agenda_block_1: ViewAgendaOverview,
  views_block__agenda_upcoming: ViewAgendaUpcoming,
  views_block__expert_content_block_1: ViewExpertContent,
  views_block__vocabulary_terms_subject: ViewDossierMenu,
  views_block__vocabulary_terms_workfield: ViewDossierMenu,
  views_block__vocabulary_terms_stage_of_life: ViewDossierMenu,
  views_block__vocabulary_terms_location: ViewDossierMenu,
  views_block__vocabulary_terms_workfield_theme: ViewWorkfieldsTheme,
  views_block__vocabulary_terms_subject_theme: ViewSubjectsTheme,
  views_block__vocabulary_terms_themes: ViewThemes,
  views_block__vocabulary_terms_pillars: ViewPillars,
  views_block__articles_promoted: ViewArticlesPromoted,
  views_block__milestones_overview_block_1: ViewMilestones,
  views_block__milestones_overview_block_2: ViewMilestones,
};

export default mappers;
